(function () {
  'use strict';

  /* =========================================================
     HI TEA OFFER SETTINGS
     CHANGE ONLY THIS BLOCK FOR FUTURE OFFERS
  ========================================================= */

  const OFFER_CONFIG = {
    active: true,

    /* Discount */
    code: 'FIRSTSIP15',
    discountPercent: 15,
    discountLabel: '15% OFF',

    /* Main popup */
    eyebrow: 'Limited welcome offer',
    title: 'Unlock 15% off your first order',
    intro:
      'Enter your details to unlock your HI TEA welcome discount.',

    /* Optional flavour promotion */
    flavourName: 'HI TEA',
    flavourMessage: 'Discover all 9 instant green tea flavours',

    /* Success screen */
    successEyebrow: 'Your welcome offer is ready',
    successTitle: '15% off unlocked',
    successMessage:
      'Copy your code or apply it instantly and start shopping.',

    /* Button */
    submitButtonText: 'UNLOCK MY 15% OFF',
    successButtonText: 'APPLY 15% OFF & SHOP',

    /* Shopify destination after applying discount */
    redirectPath: '/collections/all',

    /* Timing */
    teaserDelay: 2000,
    popupDelay: 5000,
    messageRotationDelay: 5000,
    peekInterval: 9000,

    /* If popup is closed, do not auto-open again for 24 hours */
    dismissDuration:
      24 * 60 * 60 * 1000,

    /* Shopify tags */
    tags: [
      'newsletter',
      'hi-tea-offer',
      'first-order-offer',
      'popup-signup',
      'popup-lead'
    ]
  };

  /* =========================================================
     DO NOT CHANGE BELOW UNLESS FUNCTIONALITY CHANGES
  ========================================================= */

  function initHiTeaOfferSystem() {
    const root = document.querySelector(
      '[data-ht-offer-system]'
    );

    if (
      !root ||
      root.dataset.ready === 'true'
    ) {
      return;
    }

    if (!OFFER_CONFIG.active) {
      root.style.display = 'none';
      root.dataset.ready = 'true';
      return;
    }

    const teaser = root.querySelector(
      '.ht-offer-teaser'
    );

    const modal = root.querySelector(
      '[data-ht-offer-modal]'
    );

    const openButtons = root.querySelectorAll(
      '[data-ht-offer-open], .ht-offer-teaser'
    );

    const closeButtons = root.querySelectorAll(
      '[data-ht-offer-close]'
    );

    const form = root.querySelector(
      '#HiTeaOfferForm'
    );

    const formView = root.querySelector(
      '[data-ht-offer-form-view]'
    );

    const successView = root.querySelector(
      '[data-ht-offer-success-view]'
    );

    const copyButton = root.querySelector(
      '[data-ht-copy-code]'
    );

    const titleEl = root.querySelector(
      '[data-ht-rotating-title]'
    );

    const subtitleEl = root.querySelector(
      '[data-ht-rotating-subtitle]'
    );

    const nameInput = root.querySelector(
      '[data-ht-name-input]'
    );

    const phoneInput = root.querySelector(
      '[data-ht-phone-input]'
    );

    const emailInput = root.querySelector(
      '[data-ht-email-input]'
    );

    const tagsInput = root.querySelector(
      '[data-ht-tags-input]'
    );

    const noteInput = root.querySelector(
      '[data-ht-note-input]'
    );

    const submitButton = root.querySelector(
      '[data-ht-offer-submit]'
    );

    const mainEyebrow = formView
      ? formView.querySelector(
          '.ht-offer-modal__eyebrow'
        )
      : null;

    const mainTitle = root.querySelector(
      '#htOfferTitle'
    );

    const mainIntro = formView
      ? formView.querySelector(
          '.ht-offer-modal__intro'
        )
      : null;

    const badgeStrong = root.querySelector(
      '.ht-offer-modal__badge strong'
    );

    const badgeText = root.querySelector(
      '.ht-offer-modal__badge span'
    );

    const successEyebrow = successView
      ? successView.querySelector(
          '.ht-success-premium__eyebrow, .ht-offer-modal__eyebrow'
        )
      : null;

    const successTitle = successView
      ? successView.querySelector('h2')
      : null;

    const successMessage = successView
      ? successView.querySelector(
          '.ht-success-premium__copy, .ht-offer-modal__intro'
        )
      : null;

    const successCta = successView
      ? successView.querySelector(
          '.ht-success-premium__cta, .ht-offer-success-cta'
        )
      : null;

    const successFine = successView
      ? successView.querySelector(
          '.ht-success-premium__fine'
        )
      : null;

    const storageVersion = 'v9';

    const unlockedKey =
      'hitea_offer_unlocked_' +
      storageVersion;

    const dismissedKey =
      'hitea_offer_dismissed_' +
      storageVersion;

    const autoOpenedKey =
      'hitea_offer_auto_opened_' +
      storageVersion;

    const pendingKey =
      'hitea_offer_form_pending_' +
      storageVersion;

    let currentMessageIndex = 0;
    let rotateInterval = null;
    let peekInterval = null;
    let peekTimeout = null;

    const promoMessages = [
      {
        title:
          'UNLOCK ' +
          OFFER_CONFIG.discountLabel,
        subtitle: 'Your welcome offer'
      },
      {
        title: OFFER_CONFIG.flavourName
          .toUpperCase(),
        subtitle:
          OFFER_CONFIG.flavourMessage
      },
      {
        title: 'FIRST SIP SAVINGS',
        subtitle: 'Fresh deal inside'
      },
      {
        title: 'TODAY’S TEA DROP',
        subtitle: 'Tap to reveal offer'
      }
    ];

    const unlockedMessages = [
      {
        title:
          OFFER_CONFIG.discountLabel +
          ' UNLOCKED',
        subtitle: 'Your code is ready'
      },
      {
        title: OFFER_CONFIG.code,
        subtitle: 'Use it at checkout'
      },
      {
        title: 'SHOP HI TEA',
        subtitle: 'Your offer is live'
      }
    ];

    function buildDiscountUrl() {
      return (
        '/discount/' +
        encodeURIComponent(
          OFFER_CONFIG.code
        ) +
        '?redirect=' +
        encodeURIComponent(
          OFFER_CONFIG.redirectPath
        )
      );
    }

    function applyConfiguredContent() {
      if (mainEyebrow) {
        mainEyebrow.textContent =
          OFFER_CONFIG.eyebrow;
      }

      if (mainTitle) {
        mainTitle.textContent =
          OFFER_CONFIG.title;
      }

      if (mainIntro) {
        mainIntro.textContent =
          OFFER_CONFIG.intro;
      }

      if (badgeStrong) {
        badgeStrong.textContent =
          OFFER_CONFIG.discountPercent +
          '%';
      }

      if (badgeText) {
        badgeText.textContent =
          'OFF TODAY';
      }

      if (submitButton) {
        submitButton.textContent =
          OFFER_CONFIG.submitButtonText;
      }

      if (successEyebrow) {
        successEyebrow.textContent =
          OFFER_CONFIG.successEyebrow;
      }

      if (successTitle) {
        successTitle.textContent =
          OFFER_CONFIG.successTitle;
      }

      if (successMessage) {
        successMessage.textContent =
          OFFER_CONFIG.successMessage;
      }

      if (copyButton) {
        copyButton.dataset.discountCode =
          OFFER_CONFIG.code;

        copyButton.setAttribute(
          'aria-label',
          'Copy ' +
            OFFER_CONFIG.code +
            ' discount code'
        );

        const strong =
          copyButton.querySelector(
            'strong'
          );

        if (strong) {
          strong.textContent =
            OFFER_CONFIG.code;
        } else {
          const small =
            copyButton.querySelector(
              'small'
            );

          copyButton.childNodes.forEach(
            function (node) {
              if (
                node.nodeType ===
                  Node.TEXT_NODE &&
                node.textContent.trim()
              ) {
                node.textContent =
                  '\n' +
                  OFFER_CONFIG.code +
                  '\n';
              }
            }
          );

          if (!small) {
            const copyText =
              document.createElement(
                'small'
              );

            copyText.textContent = 'Copy';
            copyButton.appendChild(
              copyText
            );
          }
        }
      }

      if (successCta) {
        successCta.href =
          buildDiscountUrl();

        const arrow =
          successCta.querySelector(
            'span'
          );

        successCta.childNodes.forEach(
          function (node) {
            if (
              node.nodeType ===
                Node.TEXT_NODE &&
              node.textContent.trim()
            ) {
              node.textContent =
                '\n' +
                OFFER_CONFIG.successButtonText +
                '\n';
            }
          }
        );

        if (!arrow) {
          const arrowElement =
            document.createElement(
              'span'
            );

          arrowElement.textContent = '→';
          successCta.appendChild(
            arrowElement
          );
        }
      }

      if (successFine) {
        successFine.textContent =
          'One-time welcome offer. Valid on your first order.';
      }

      root
        .querySelectorAll(
          'a[href*="/discount/"]'
        )
        .forEach(function (link) {
          link.href =
            buildDiscountUrl();
        });
    }

    function cleanTagValue(value) {
      return String(value || '')
        .trim()
        .replace(
          /[^\dA-Za-z+-]/g,
          ''
        )
        .slice(0, 40);
    }

    function hasUnlocked() {
      return (
        localStorage.getItem(
          unlockedKey
        ) === 'true'
      );
    }

    function setUnlocked() {
      localStorage.setItem(
        unlockedKey,
        'true'
      );

      localStorage.removeItem(
        dismissedKey
      );
    }

    function wasRecentlyDismissed() {
      const dismissedAt = Number(
        localStorage.getItem(
          dismissedKey
        )
      );

      if (!dismissedAt) {
        return false;
      }

      return (
        Date.now() - dismissedAt <
        OFFER_CONFIG.dismissDuration
      );
    }

    function setDismissed() {
      localStorage.setItem(
        dismissedKey,
        String(Date.now())
      );
    }

    function getMessageSet() {
      return hasUnlocked()
        ? unlockedMessages
        : promoMessages;
    }

    function applyMessage(index) {
      const messageSet =
        getMessageSet();

      if (!messageSet.length) {
        return;
      }

      const item =
        messageSet[
          index % messageSet.length
        ];

      if (titleEl) {
        titleEl.textContent =
          item.title;
      }

      if (subtitleEl) {
        subtitleEl.textContent =
          item.subtitle;
      }
    }

    function nextMessage() {
      const messageSet =
        getMessageSet();

      if (!messageSet.length) {
        return;
      }

      currentMessageIndex =
        (currentMessageIndex + 1) %
        messageSet.length;

      applyMessage(
        currentMessageIndex
      );
    }

    function startMessageRotation() {
      clearInterval(
        rotateInterval
      );

      currentMessageIndex = 0;

      applyMessage(
        currentMessageIndex
      );

      rotateInterval =
        setInterval(
          nextMessage,
          OFFER_CONFIG.messageRotationDelay
        );
    }

    function showForm() {
      if (formView) {
        formView.hidden = false;
      }

      if (successView) {
        successView.hidden = true;
      }
    }

    function showSuccess() {
      if (formView) {
        formView.hidden = true;
      }

      if (successView) {
        successView.hidden = false;
      }

      if (teaser) {
        teaser.classList.add(
          'is-unlocked'
        );
      }

      currentMessageIndex = 0;

      applyMessage(
        currentMessageIndex
      );
    }

    function openModal() {
      if (!modal) {
        return;
      }

      modal.classList.add(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'ht-offer-open'
      );

      if (hasUnlocked()) {
        showSuccess();
      } else {
        showForm();

        setTimeout(function () {
          if (
            nameInput &&
            !nameInput.value.trim()
          ) {
            nameInput.focus();
            return;
          }

          if (
            emailInput &&
            !emailInput.value.trim()
          ) {
            emailInput.focus();
          }
        }, 250);
      }
    }

    function closeModal(
      rememberDismissal
    ) {
      if (!modal) {
        return;
      }

      modal.classList.remove(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'ht-offer-open'
      );

      if (
        rememberDismissal &&
        !hasUnlocked()
      ) {
        setDismissed();
      }
    }

    function runPeek() {
      if (
        !teaser ||
        !modal ||
        modal.classList.contains(
          'is-open'
        )
      ) {
        return;
      }

      teaser.classList.add(
        'is-peek'
      );

      clearTimeout(peekTimeout);

      peekTimeout =
        setTimeout(function () {
          teaser.classList.remove(
            'is-peek'
          );
        }, 1800);
    }

    function startPeekLoop() {
      clearInterval(
        peekInterval
      );

      setTimeout(function () {
        runPeek();
      }, 2200);

      peekInterval =
        setInterval(
          runPeek,
          OFFER_CONFIG.peekInterval
        );
    }

    function showTeaser() {
      if (!teaser) {
        return;
      }

      teaser.classList.add(
        'is-visible'
      );

      if (hasUnlocked()) {
        teaser.classList.add(
          'is-unlocked'
        );
      }

      startMessageRotation();
      startPeekLoop();
    }

    function showUnlockedTeaser() {
      if (!teaser) {
        return;
      }

      teaser.classList.add(
        'is-visible',
        'is-unlocked',
        'is-peek'
      );

      startMessageRotation();
      startPeekLoop();

      clearTimeout(peekTimeout);

      peekTimeout =
        setTimeout(function () {
          teaser.classList.remove(
            'is-peek'
          );
        }, 2600);
    }

    function normalizeIndianPhone(
      value
    ) {
      let digits = String(
        value || ''
      ).replace(/\D/g, '');

      if (
        digits.length === 12 &&
        digits.startsWith('91')
      ) {
        digits = digits.slice(2);
      }

      return digits;
    }

    function isValidIndianPhone(
      value
    ) {
      const phone =
        normalizeIndianPhone(
          value
        );

      return /^[6-9]\d{9}$/.test(
        phone
      );
    }

    function validateForm() {
      if (
        !nameInput ||
        !nameInput.value.trim()
      ) {
        if (nameInput) {
          nameInput.setCustomValidity(
            'Please enter your name.'
          );

          nameInput.reportValidity();
        }

        return false;
      }

      nameInput.setCustomValidity(
        ''
      );

      if (
        !phoneInput ||
        !isValidIndianPhone(
          phoneInput.value
        )
      ) {
        if (phoneInput) {
          phoneInput.setCustomValidity(
            'Please enter a valid 10-digit Indian mobile number.'
          );

          phoneInput.reportValidity();
        }

        return false;
      }

      phoneInput.setCustomValidity(
        ''
      );

      if (
        !emailInput ||
        !emailInput.value.trim() ||
        !emailInput.checkValidity()
      ) {
        if (emailInput) {
          emailInput.reportValidity();
        }

        return false;
      }

      emailInput.setCustomValidity(
        ''
      );

      return true;
    }

    function enrichShopifyFormData() {
      const name = nameInput
        ? nameInput.value.trim()
        : '';

      const phone = phoneInput
        ? normalizeIndianPhone(
            phoneInput.value
          )
        : '';

      const email = emailInput
        ? emailInput.value.trim()
        : '';

      if (phoneInput) {
        phoneInput.value = phone;
      }

      const phoneTag = phone
        ? 'phone-' +
          cleanTagValue(phone)
        : '';

      const campaignTag =
        'offer-' +
        cleanTagValue(
          OFFER_CONFIG.code
        ).toLowerCase();

      const flavourTag =
        'flavour-' +
        cleanTagValue(
          OFFER_CONFIG.flavourName
        ).toLowerCase();

      const tags = [
        ...OFFER_CONFIG.tags,
        campaignTag,
        flavourTag
      ];

      if (phoneTag) {
        tags.push(phoneTag);
      }

      if (tagsInput) {
        tagsInput.value =
          tags.join(',');
      }

      if (noteInput) {
        noteInput.value = [
          'HI TEA popup signup',
          name
            ? 'Name: ' + name
            : '',
          email
            ? 'Email: ' + email
            : '',
          phone
            ? 'Phone: ' + phone
            : '',
          'Offer: ' +
            OFFER_CONFIG.code,
          'Discount: ' +
            OFFER_CONFIG.discountLabel,
          'Flavour: ' +
            OFFER_CONFIG.flavourName,
          'Source: website popup'
        ]
          .filter(Boolean)
          .join(' | ');
      }
    }

    function resetSubmitButton() {
      if (!submitButton) {
        return;
      }

      submitButton.disabled =
        false;

      submitButton.textContent =
        OFFER_CONFIG.submitButtonText;
    }

    function fallbackCopy(code) {
      const temporaryInput =
        document.createElement(
          'input'
        );

      temporaryInput.value = code;

      temporaryInput.setAttribute(
        'readonly',
        'readonly'
      );

      temporaryInput.style.position =
        'fixed';

      temporaryInput.style.opacity =
        '0';

      document.body.appendChild(
        temporaryInput
      );

      temporaryInput.select();

      document.execCommand(
        'copy'
      );

      temporaryInput.remove();
    }

    function showCopiedState() {
      if (!copyButton) {
        return;
      }

      copyButton.classList.add(
        'is-copied'
      );

      const small =
        copyButton.querySelector(
          'small'
        );

      if (small) {
        small.textContent =
          'Copied';
      }

      setTimeout(function () {
        copyButton.classList.remove(
          'is-copied'
        );

        if (small) {
          small.textContent =
            'Copy';
        }
      }, 1400);
    }

    function copyDiscountCode() {
      if (!copyButton) {
        return;
      }

      const code =
        OFFER_CONFIG.code;

      if (
        navigator.clipboard &&
        navigator.clipboard.writeText
      ) {
        navigator.clipboard
          .writeText(code)
          .then(showCopiedState)
          .catch(function () {
            fallbackCopy(code);
            showCopiedState();
          });
      } else {
        fallbackCopy(code);
        showCopiedState();
      }
    }

    function cleanSuccessUrl() {
      const currentUrl =
        new URL(
          window.location.href
        );

      currentUrl.searchParams.delete(
        'customer_posted'
      );

      const cleanHash =
        currentUrl.hash ===
        '#HiTeaOfferForm'
          ? ''
          : currentUrl.hash;

      window.history.replaceState(
        {},
        document.title,
        currentUrl.pathname +
          currentUrl.search +
          cleanHash
      );
    }

    applyConfiguredContent();

    openButtons.forEach(function (
      button
    ) {
      button.addEventListener(
        'click',
        openModal
      );
    });

    closeButtons.forEach(function (
      button
    ) {
      button.addEventListener(
        'click',
        function () {
          closeModal(true);
        }
      );
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape'
        ) {
          closeModal(true);
        }
      }
    );

    if (nameInput) {
      nameInput.addEventListener(
        'input',
        function () {
          nameInput.setCustomValidity(
            ''
          );
        }
      );
    }

    if (phoneInput) {
      phoneInput.addEventListener(
        'input',
        function () {
          phoneInput.setCustomValidity(
            ''
          );

          const cleaned =
            phoneInput.value.replace(
              /[^\d+\s-]/g,
              ''
            );

          if (
            cleaned !==
            phoneInput.value
          ) {
            phoneInput.value =
              cleaned;
          }
        }
      );
    }

    if (emailInput) {
      emailInput.addEventListener(
        'input',
        function () {
          emailInput.setCustomValidity(
            ''
          );
        }
      );
    }

    if (copyButton) {
      copyButton.addEventListener(
        'click',
        copyDiscountCode
      );
    }

    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          if (!validateForm()) {
            event.preventDefault();
            return;
          }

          enrichShopifyFormData();

          if (submitButton) {
            submitButton.disabled =
              true;

            submitButton.textContent =
              'UNLOCKING...';
          }

          sessionStorage.setItem(
            pendingKey,
            'true'
          );

          /*
            Shopify submits the form normally.
            Do not use event.preventDefault()
            after successful validation.
          */
        }
      );
    }

    const currentUrl =
      new URL(
        window.location.href
      );

    const customerPosted =
      currentUrl.searchParams.get(
        'customer_posted'
      ) === 'true';

    const formWasPending =
      sessionStorage.getItem(
        pendingKey
      ) === 'true';

    if (
      customerPosted &&
      formWasPending
    ) {
      sessionStorage.removeItem(
        pendingKey
      );

      setUnlocked();

      closeModal(false);

      showUnlockedTeaser();

      resetSubmitButton();

      cleanSuccessUrl();
    } else {
      setTimeout(
        showTeaser,
        OFFER_CONFIG.teaserDelay
      );
    }

    if (
      !customerPosted &&
      !hasUnlocked() &&
      !wasRecentlyDismissed() &&
      sessionStorage.getItem(
        autoOpenedKey
      ) !== 'true'
    ) {
      setTimeout(function () {
        if (
          !hasUnlocked() &&
          !wasRecentlyDismissed() &&
          modal &&
          !modal.classList.contains(
            'is-open'
          )
        ) {
          sessionStorage.setItem(
            autoOpenedKey,
            'true'
          );

          openModal();
        }
      }, OFFER_CONFIG.popupDelay);
    }

    root.dataset.ready = 'true';
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initHiTeaOfferSystem
    );
  } else {
    initHiTeaOfferSystem();
  }

  document.addEventListener(
    'shopify:section:load',
    initHiTeaOfferSystem
  );
})();